<ca-modal-container [modalTitle]="'WORKFLOWS.METADATA_EDITOR.HEADLINE' | translate" (dismiss)="dismiss('Canceled')">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" class="row gy-2">
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <input
                    type="text"
                    class="form-control"
                    id="title"
                    [placeholder]="'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.TITLE.PLACEHOLDER' | translate"
                    formControlName="title"
                    data-uit="workflows-metadata-modal-title-input"
                    [ngClass]="formGroup.get('title')?.errors ? 'has-error' : ''"
                />
                <label for="title">{{ 'GENERAL.TITLE' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('title')?.dirty && formGroup.get('title')?.hasError('pattern')" class="invalid-feedback">
                {{ 'WORKFLOWS.METADATA_EDITOR.ERROR_WORKFLOW_WHITESPACE' | translate }}
            </small>
            <small *ngIf="formGroup.get('title')?.dirty && formGroup.get('title')?.hasError('maxlength')" class="invalid-feedback">
                {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Title', limit: titleLengthLimit } }}
            </small>
            <small *ngIf="formGroup.get('title')?.dirty && formGroup.get('title')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <textarea
                    class="form-control"
                    id="summary"
                    placeholder="{{ 'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.SHORT_SUMMARY.PLACEHOLDER' | translate }}"
                    formControlName="summary"
                    data-uit="workflows-metadata-modal-summary-input"
                    [ngClass]="formGroup.get('summary')?.errors && formGroup.get('summary')?.touched ? 'has-error' : ''"
                ></textarea>
                <label for="summary">{{ 'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.SHORT_SUMMARY.LABEL' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('maxlength')" class="invalid-feedback">
                {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Summary', limit: summaryLengthLimit } }}
            </small>
            <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mb-3 form-group">
            <div class="d-flex flex-column-reverse">
                <ca-quill-editor-wrapper
                    id="description"
                    formControlName="description"
                    [placeholder]="'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.DETAILED_DESCRIPTION.PLACEHOLDER' | translate"
                    data-uit="workflows-metadata-modal-detailed-description-input"
                    [required]="true"
                    (touched)="onTouched()"
                    [ngClass]="description.touched && description.errors ? 'has-error' : ''"
                ></ca-quill-editor-wrapper>

                <label for="description"
                    >{{ 'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.DETAILED_DESCRIPTION.LABEL' | translate }} <span class="red">*</span></label
                >
            </div>
            <small *ngIf="description.touched && description.errors?.maxLength" class="invalid-feedback">
                {{ 'MODULES.EDITOR.DESCRIPTION_TOO_LONG' | translate: { descriptionLengthLimit: descriptionLengthLimit } }}
            </small>
            <small *ngIf="description.touched && description.errors?.required" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mb-3 form-group">
            <div class="d-flex flex-column-reverse">
                <ng-select
                    *ngIf="categories"
                    labelForId="category"
                    formControlName="categoryId"
                    [placeholder]="'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.CATEGORY.PLACEHOLDER' | translate"
                    appendTo="body"
                    [searchable]="false"
                    [clearable]="false"
                    data-uit="workflows-metadata-modal-select-category"
                >
                    <ng-option *ngFor="let category of categories" [value]="category.id">{{ category?.name }}</ng-option>
                </ng-select>
                <label for="category">{{ 'GENERAL.CATEGORY' | translate }}</label>
            </div>
            <small *ngIf="formGroup.get('categoryId')?.touched && formGroup.get('categoryId')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="d-flex flex-column-reverse mb-3 form-group" *ngIf="asAdmin && isPublicWorkflow">
            <ng-select
                labelForId="machine-learning"
                formControlName="type"
                [placeholder]="'WORKFLOWS.METADATA_EDITOR.MACHINE_LEARNING.PLACEHOLDER' | translate"
                appendTo="body"
                [multiple]="false"
                [searchable]="false"
                [clearable]="true"
            >
                <ng-option *ngFor="let type of types" [value]="type.value">{{ type.name }}</ng-option>
            </ng-select>
            <label for="machine-learning">{{ 'WORKFLOWS.METADATA_EDITOR.MACHINE_LEARNING.LABEL' | translate }} <span class="red">*</span></label>
        </div>
        <div class="d-flex flex-column-reverse mb-3 form-group" *ngIf="asAdmin && isPublicWorkflow">
            <ng-select
                labelForId="machine-learning"
                formControlName="segmentationTypeSupported"
                [placeholder]="'WORKFLOWS.METADATA_EDITOR.SUPPORTED_TYPE.PLACEHOLDER' | translate"
                appendTo="body"
                [multiple]="false"
                [searchable]="false"
                [clearable]="true"
            >
                <ng-option *ngFor="let segmentationType of segmentationTypes" [value]="segmentationType.value">{{ segmentationType.name }}</ng-option>
            </ng-select>
            <label for="machine-learning">{{ 'WORKFLOWS.METADATA_EDITOR.SUPPORTED_TYPE.LABEL' | translate }} <span class="red">*</span></label>
        </div>
        <div class="d-flex flex-column-reverse mb-3" *ngIf="asAdmin && isPublicWorkflow">
            <input type="number" formControlName="mlVersion" appendTo="body" class="form-control" />
            <label for="mlVersion">{{ 'WORKFLOWS.EDITOR.ML_VERSION' | translate }}</label>
        </div>
        <ca-input-checkbox formControlName="isFeatured" appendTo="body" *ngIf="asAdmin && isPublicWorkflow">
            {{ 'WORKFLOWS.EDITOR.IS_FEATURED_WORKFLOW' | translate }}
        </ca-input-checkbox>
        <div class="file-upload-panel mb-3" *ngIf="asAdmin && isPublicWorkflow">
            <div class="mb-2">
                <h4 class="title">{{ 'WORKFLOWS.METADATA_EDITOR.FILE_UPLOAD_PANEL.LABEL' | translate }}</h4>
                <span class="title-info">{{ 'WORKFLOWS.METADATA_EDITOR.FILE_UPLOAD_PANEL.INFO' | translate }}</span>
            </div>
            <div class="wrap">
                <ca-file-upload
                    [blobType]="workflowImageBlobType"
                    [pathToAppend]="workflow.id"
                    [maxInputSizeInBytes]="maxInputSizeInBytes"
                    [uploaderKey]="'workflow_editor_upload_' + workflow.id"
                    [supportedFileTypes]="supportedImageTypes"
                    [isDisabled]="maxImagesFull"
                    [errorNotificationMode]="'notification'"
                    (onUploadCompleted)="onUploadCompleted($event)"
                ></ca-file-upload>
                <div class="max-images-info py-2 font-m">
                    <ng-container *ngIf="!maxImagesFull; else imagesFull">
                        {{ 'WORKFLOWS.METADATA_EDITOR.FILE_UPLOAD_PANEL.MAX_IMAGES_INFO' | translate: { maxImages: maxImages } }}
                    </ng-container>
                    <ng-template #imagesFull>
                        {{ 'WORKFLOWS.METADATA_EDITOR.FILE_UPLOAD_PANEL.IMAGES_FULL' | translate: { maxImages: maxImages } }}
                    </ng-template>
                </div>
                <div class="exist-item" *ngFor="let fileName of imageFileNames; let i = index" #imageRef>
                    <span class="file-name">{{ fileName }}</span>
                    <button
                        type="button"
                        class="btn ca-btn-icon ca-btn-icon-small"
                        (click)="removeFileItem(i)"
                        data-uit="workflows-metadata-modal-remove-uploaded-image"
                    >
                        <ca-icon name="cross" size="s"></ca-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button type="submit" [disabled]="isSubmitting || formGroup.invalid" class="btn btn-primary" data-uit="workflows-metadata-modal-save-btn">
                {{ 'GENERAL.SAVE' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
